export default  {
  bindings: {
    order: '=',
  },
  controller: 'orderNotesController',
  template: require('../views/order.notes.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/components/order.notes.component.js